import { updateVar } from '../__utils/setVar';
const $ = jQuery.noConflict();

class alertBar {
    constructor(bar = '.alert-bar', close = '.alert-bar__close') {
        this.bar = bar;
        this.close = close;
    }

    init() {
        this.closeAlertBar();
    }

    closeAlertBar() {
        $(this.close).on('click', () => {
            const date = new Date();
            const endDate = date.setDate( date.getDate() + 1 );


            $(this.bar).remove();
            document.cookie = `alertBar=true; expires=${endDate.toUTCString}; path=/`;
            updateVar();
        });
    }
}

export default new alertBar();
